//const { Cookies: Cookies_ } = require("react-cookie");
//const cook = new Cookies_();

export const credenciales = async () => {
  let IdSesion = Number(window.localStorage.getItem("IdSesion")) + 0;
  let tokenBacked = window.localStorage.getItem("TokenApi") + "";
  return { IdSesion, tokenBacked };
};
